// @flow
import React, { PureComponent, Fragment } from 'react';
import Slider from 'components/Slider';
import Button01 from 'components/Button/Button01';
import BlendControl from 'components/BlendControl';
import type { ShaderSettings } from 'components/shaders/LineShader';
import type { DroppedImage } from 'components/ImageDrop';
import type { Resolution } from 'types/Settings';

import {
  Wrap,
  Title,
  ColorWrap,
  Color,
  Input,
  BlendModesWrap,
  ResolutionWrap,
  ResolutionSpacer,
  IconButton,
} from './ImageControls.styled';

type Props = {
  shaderSettings: ShaderSettings,
  onChangeShaderSettings: (settings: ShaderSettings) => void,
  onChangeResolution: (resolution: Resolution) => void,
  onResetResolution: (e: Event) => void,
  resolution: Resolution,
  resetCropDisabled: boolean,
  onResetCrop: () => void,
};

type State = {};

const AVAILABLE_COLORS = ['#e22a1D', '#30f80f'];

class ImageControls extends PureComponent<Props, State> {
  handleValueChange = (key: string, value: string) => {
    const { shaderSettings } = this.props;
    shaderSettings[key] = value;
    this.didUpdateSettings(shaderSettings);
  };

  handleResolutionChange = (key: string, value: number) => {
    if (Number.isNaN(value)) return;

    const { resolution, onChangeResolution } = this.props;
    const { ratio } = resolution;
    const newResolution = JSON.parse(JSON.stringify(resolution));

    if (key === 'width') {
      newResolution.width = value;
      newResolution.height = value / ratio;
    } else if (key === 'height') {
      newResolution.height = value;
      newResolution.width = value * ratio;
    }

    if (
      onChangeResolution &&
      newResolution.width !== resolution.width &&
      newResolution.height !== resolution.height
    ) {
      onChangeResolution(newResolution);
    }
  };

  handleBlendModeChange = (type: string) => {
    const { shaderSettings } = this.props;
    shaderSettings.blend = type;
    this.didUpdateSettings(shaderSettings);
  };

  handleColorChange = (color: string) => {
    const { shaderSettings } = this.props;
    shaderSettings.color = color;
    this.didUpdateSettings(shaderSettings);
  };

  didUpdateSettings = (settings: ShaderSettings) => {
    const { onChangeShaderSettings } = this.props;
    if (onChangeShaderSettings) onChangeShaderSettings(settings);
  };

  isVisible = fieldName => this.props.hidden.indexOf(fieldName) === -1;

  render() {
    const {
      shaderSettings: { contrast, brightness, thickness, blend, color },
      resolution,
      onResetResolution,
      resetCropDisabled,
      onResetCrop,
    } = this.props;

    return (
      <Wrap>
        <Title>IMAGE CONTROLS</Title>
        {this.isVisible('brightness') && (
          <Slider
            name="Brightness"
            value={brightness}
            min={0}
            max={100}
            step={1}
            onChange={(e, value) => {
              this.handleValueChange('brightness', value);
            }}
          />
        )}
        {this.isVisible('contrast') && (
          <Slider
            name="Contrast"
            value={contrast}
            min={0}
            max={100}
            step={1}
            onChange={(e, value) => {
              this.handleValueChange('contrast', value);
            }}
          />
        )}
        {this.isVisible('thickness') && (
          <Slider
            name="Thickness"
            value={thickness}
            min={0}
            max={50}
            step={1}
            onChange={(e, value) => {
              this.handleValueChange('thickness', value);
            }}
          />
        )}
        {/* <Title>COLOR</Title>
        <ColorWrap>
          {AVAILABLE_COLORS.map(c => (
            <Color
              key={c}
              color={c}
              isActive={c === color}
              onClick={() => {
                this.handleColorChange(c);
              }}
            />
          ))}
        </ColorWrap> */}
        {this.isVisible('blend') && (
          <Fragment>
            <Title>BLEND MODES</Title>
            <BlendModesWrap>
              <BlendControl
                isActive={blend === 'none'}
                type="none"
                onClick={this.handleBlendModeChange}
              />
              <BlendControl
                isActive={blend === 'multiply'}
                type="multiply"
                onClick={this.handleBlendModeChange}
              />
              <BlendControl
                isActive={blend === 'screen'}
                type="screen"
                onClick={this.handleBlendModeChange}
              />
            </BlendModesWrap>
          </Fragment>
        )}
        {this.isVisible('resolution') && (
          <Fragment>
            <Title>RESOLUTION</Title>
            <ResolutionWrap>
              <Input
                type="text"
                pattern="[0-9]*"
                disabled={!resolution}
                value={resolution ? Math.round(resolution.width) : ''}
                onChange={e => {
                  this.handleResolutionChange('width', Number(e.target.value));
                }}
              />
              <ResolutionSpacer>x</ResolutionSpacer>
              <Input
                type="text"
                pattern="[0-9]*"
                disabled={!resolution}
                value={resolution ? Math.round(resolution.height) : ''}
                onChange={e => {
                  this.handleResolutionChange('height', Number(e.target.value));
                }}
              />
              <IconButton
                onClick={onResetResolution}
                alt="refresh"
                src="/assets/images/refresh.png"
              />
            </ResolutionWrap>
          </Fragment>
        )}
        {!this.isVisible('resolution') &&
          resolution && (
            <Button01
              title="RESET CROP"
              disabled={resetCropDisabled}
              onClick={onResetCrop}
            />
          )}
      </Wrap>
    );
  }
}

export default ImageControls;



// WEBPACK FOOTER //
// /opt/build/repo/src/modules/main/components/ImageControls/ImageControls.js